export default "__VITE_ASSET__2bc8dd05__"